import React from 'react';
import classNames from 'classnames';

import { PaddingContainer, WidthContainer } from '@components';
import { UnderlinedHeader } from '@components/typographies';

import * as styles from './Header.module.scss';

export const Header: React.FC = () => {
	return (
		<PaddingContainer
			className={classNames('white-bg relative', styles.wrapper)}
		>
			<WidthContainer className={styles.container}>
				<UnderlinedHeader
					subtitleClassName="font-400"
					subtitle="Innovative AI solutions tailored to your needs."
				>
					AI Development Services
				</UnderlinedHeader>
			</WidthContainer>
		</PaddingContainer>
	);
};
